import Validator from '../validator';

export class ModelValidator extends Validator {
  static validate(model) {
    return !!model?.isValid;
  }
}

export default { ModelValidator };
